import { env } from "@/env";

type AddToCartUrlOptions = {
  variantId: string;
  quantity?: number;
  redirectTo?: string;
  sellingPlan?: string | null;
  attributes?: Record<string, string>;
};

export const buildAddToCartCartUrl = ({
  attributes,
  quantity = 1,
  redirectTo = "/checkout",
  sellingPlan = null,
  variantId,
}: AddToCartUrlOptions) => {
  const baseUrl = `${env.VITE_SHOPIFY_DOMAIN}/cart/add`;
  const params = new URLSearchParams({
    id: variantId,
    quantity: `${quantity}`,
    return_to: redirectTo,
  });

  if (sellingPlan) {
    params.set("selling_plan", sellingPlan);
  }

  if (attributes) {
    Object.entries(attributes).forEach(([key, value]) => {
      params.set(`attributes[${key}]`, value);
    });
  }

  return `${baseUrl}?${params.toString()}`;
};
